'use strict';

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var domCache = require('dom-cache');
var scrollToElement = require('scroll-to-element');
var dom;

var setupDom = function() {

	dom = {};
	dom.signUpBtn = $('.header__sign-up-btn');
	dom.buyNowBtn = $('.product-banner__buy-now-btn,.product-banner__sign-up-btn');
	dom.suggestedProducts = $('[name="suggested-products"]');

};

var addEventHandlers = function() {

	dom.signUpBtn.on('click', onSignUpBtnClick);
	dom.buyNowBtn.on('click', onSignUpBtnClick);
	domCache.document.on('checkout_form_loaded', onCheckoutReady);

};

var onCheckoutReady = function() {

	if (window.location.pathname === '/sign-up' && window.location.href.indexOf('photobiz.com') >= 0) {
		scrollToCheckoutForm();
	}

};

var scrollToCheckoutForm = function() {

	// disabling for now as they always want
	// to scroll to checkout form (rather than suggested products)
	if (false && dom.suggestedProducts.length) {

		scrollToElement({
			element: '[name="suggested-products"]',
			speed: 500,
			scrollTopOffset: 275,
			force: true
		});

	} else {

		scrollToElement({
			element: '[name="checkout-form"]',
			speed: 500,
			scrollTopOffset: 150,
			force: true
		});
		
	}


};

var onSignUpBtnClick = function(e) {

	e.preventDefault();

	dom.checkoutForm = $('[name="checkout-form"]');

	if (dom.checkoutForm.length) {
		
		scrollToCheckoutForm();

	} else {

		window.location = '/sign-up';

	}

};

var init = function() {
	
	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};
